/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts
 */

import { FieldType } from "../../type-system/FieldType";
import { ShopifyCountryKey, ShopifyCountryToShopKey, ShopifyProvinceKey, ShopifyProvinceToCountryKey, ShopifyShopKey } from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyCountryKey,
  "2022-01": {
    name: "Shopify Country",
    fields: [
      {
        name: "Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "code" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Provinces",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "provinces" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyProvinceKey,
          inverseFieldKey: ShopifyProvinceToCountryKey,
        },
      },
      {
        name: "Tax",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCountryToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "country" },
  },
  "2025-04": {
    isDisconnected: true,
  },
};

export const ShopifyCountry = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
